import styled from 'styled-components';
import C from '@assets/themes/colors';


interface IRootProps {
  widthValue?: string;
  heightValue?: string;
  topValue?: string;
  leftValue?: string;
  rightValue?: string;
  rotationValue?: string;
  opacityValue?: number;
  marginTop?: string;
  textAlign?: string;
  move?: string;
};

export const Root = styled.div`
    position: relative;
    width: 100%;
    height: ${(props: IRootProps) => props.heightValue ? props.heightValue : 'calc(100% - 75px)'};
    justify-content: center;
    margin-top: ${(props: IRootProps) => props.marginTop ? props.marginTop: '81px' };
    transition: width 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Container = styled.div`
  padding: 24px 46px 0px 46px;
  top: 0px;
  left: 0px;
  width: calc(100% - 92px);
  height: 100%;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 33px;
  position: relative;
  width: 100%;
`;

export const Transition = styled.div`
  text-align: ${(props: IRootProps) => props.textAlign};
  position: relative;
  white-space: nowrap;
  width: ${(props: IRootProps) => props.move ? '0px':'100%'};
  transition: width 2s ease;
`;

export const ChipsCol = styled.div`
  width:max-content;
  display:inline-block;
`;

export const ChipsContainer = styled.div`
  width:auto;
  display:inline-block;
  position:${(props: IRootProps) => props.move!='0%' ? 'absolute' : ''};
  left:${(props: IRootProps) => props.move!='0%' ? '36%' : ''};
`;

export const IconContainer = styled.div`
  width:37px;
  height:36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
  top: 15%;
  &:hover {
    border-radius: 40px;
    background-color: rgba(255, 255, 255, 0.2);
  }
  @media (max-width: 1300px) {
    right:-12px;
  }
`;

export const ViewOrderContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 2px 0px 0px 0px;
`;

export const lineSeparator = styled.div`
  width: 39px;
  height: 1px;
  margin: 24px 0px;
  transform: rotate(-270deg);
  background-color: rgba(255, 255, 255, 0.5);
`;